import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import actions from "../../store/auth/actions";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Typography,
} from "antd";
import Title from "antd/es/typography/Title";
import { EditOutlined } from "@ant-design/icons";
import "./index.css";
import lifeTime from "../../assets/images/lifetime.svg";
import AvailablePoints from "../../assets/images/availablePoint.svg";
import pointsRedeemed from "../../assets/images/programSaving.svg";
import expired from "../../assets/images/Pointexpiry.svg";
import { isEmpty } from "lodash";
import moment from "moment/moment";
import axiosInstance from "../../helpers";
import SimpleReactValidator from "simple-react-validator";

// import moment from "moment/moment";
// import moment from "moment";

const Account = () => {
  const [modal, setModal] = useState(false);
  // const [memberProfile, setMemberProfile] = useState([])
  // const [start, setStart] = useState(false)

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  // useEffect(() => {
  //   if (start) {
  //     const fetchMemberProfiles = async () => {
  //       try {
  //         const response = await axiosInstance.get('Api/member_profile_update');
  //         console.log(response.data, 'API response');
  //         setMemberProfile(response.data); // Assuming the data you need is in response.data.data
  //       } catch (error) {
  //         console.error('Error fetching member profiles:', error);
  //       }
  //     };

  //     fetchMemberProfiles();
  //   }

  // }, [])

  // const [error, setError] = useState("");

  // const dispatch = useDispatch();
  // const { account_List
  //   // , loading, error
  //  } = useSelector((state) => state.MyAccount);

  // useEffect(() => {
  //   dispatch(actions.myAccountApi());
  // }, [dispatch]);

  // const handleEdit = () => {

  // }

  const userDetails = localStorage.getItem("sessionUser");

  console.log(userDetails, "userDetails");

  const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
  console.log(userInfo, "userInfo");

  const userInfoDetails =
    !isEmpty(userInfo) &&
    userInfo.data &&
    userInfo.data.data &&
    userInfo.data.data.user
      ? userInfo.data.data.user
      : "";

  const scrollRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [userResponseData, setUserResponseData] = useState("");

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX);
    setScrollLeft(scrollRef.current.scrollLeft);
    scrollRef.current.style.cursor = "grabbing";
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    scrollRef.current.style.cursor = "grab";
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX) * 5; // Adjust the multiplier for smoother scroll
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX;
    const walk = (x - startX) * 1; // Adjust the multiplier for smoother scroll
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const dob = userInfoDetails ? userInfoDetails.dob.slice(0, 1) : "";
  const anniversary = userInfoDetails
    ? userInfoDetails.anniversary_date.slice(0, 1)
    : "";

  console.log(userInfoDetails, "userInfoDetails");
  console.log(dob, anniversary, "dates");
  console.log(userResponseData, "userResponseData");
  const userDataResponse =
    !isEmpty(userResponseData) && userResponseData ? userResponseData.user : "";
  const items = [
    {
      key: "1",
      label: "First Name",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.first_name
        : userInfoDetails
        ? userInfoDetails.first_name
        : "",
    },
    {
      key: "2",
      label: "Last Name",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.last_name
        : userInfoDetails
        ? userInfoDetails.last_name
        : "",
    },
    {
      key: "3",
      label: "Email Address",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.email
        : userInfoDetails
        ? userInfoDetails.email
        : "",
    },
    {
      key: "4",
      label: "Date of Birth",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.dob
        : userInfoDetails && dob !== 0
        ? userInfoDetails.dob
        : "--",
    },
    {
      key: "5",
      label: "Mobile Number",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.mobile
        : userInfoDetails
        ? userInfoDetails.mobile
        : "",
    },
    {
      key: "6",
      label: "Anniversary",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.anniversary_date
        : userInfoDetails && anniversary !== 0
        ? userInfoDetails.anniversary_date
        : "--",
    },
    {
      key: "7",
      label: "Gender",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.gender
        : userInfoDetails
        ? userInfoDetails.gender
        : "",
    },
    {
      key: "8",
      label: "Source",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.source
        : userInfoDetails
        ? userInfoDetails.source
        : "",
    },
    {
      key: "9",
      label: "Occupation",
      value: !isEmpty(userDataResponse)
        ? userDataResponse.occupation
        : userInfoDetails
        ? userInfoDetails.occupation
        : "",
    },
  ];

  const [source, setSource] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [gender, setGender] = useState([]);
  const [dobDate, setDob] = useState("");
  const [anniversaryDate, setAnniversary] = useState("");

  const [userInfoData, setUserInfoData] = React.useState({
    _id: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    Occupation: "",
    secretKey: "",
  });

  console.log(dobDate, anniversaryDate, "date");

  const handleChange = (e) => {
    setUserInfoData({
      ...userInfoData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (userInfoDetails) {
      setUserInfoData({
        _id: userInfoDetails.id,
        firstName: userInfoDetails.first_name,
        lastName: userInfoDetails.last_name,
        mobile: userInfoDetails.mobile,
        email: userInfoDetails.email,
      });
      setOccupation({
        value: userInfoDetails.occupation,
        label: userInfoDetails.occupation,
      });
      setSource({
        value: userInfoDetails.source,
        label: userInfoDetails.source,
      });
      setGender({
        value: userInfoDetails.gender,
        label: userInfoDetails.gender,
      });
      setDob(
        userInfoDetails.dob
          ? moment(userInfoDetails.dob, "YYYY-MM-DD") || userInfoDetails.dob
          : null
      );
      setAnniversary(
        userInfoDetails.anniversary_date
          ? moment(userInfoDetails.anniversary_date, "YYYY-MM-DD")
          : null
      );
    }
  }, [modal]);

  const updateProfile = () => {
    if (simpleValidator.current.allValid()) {
      const updateData = {
        user_id: userInfoData._id,
        first_name: userInfoData.firstName,
        last_name: userInfoData.lastName,
        email: userInfoData.email,
        mobile: userInfoData.mobile,
        dob: dobDate ? dobDate.format("YYYY-MM-DD") : "",
        anniversary_date: anniversaryDate
          ? anniversaryDate.format("YYYY-MM-DD")
          : "",
        gender: gender ? gender.value || gender : "",
        source: source ? source.value || source : "",
        occupation: occupation ? occupation.value || occupation : "",
      };
      axiosInstance
        .post("Api/member_profile_update", updateData)
        .then((response) => {
          console.log(response.data, "response data");
          setUserResponseData(response.data.data);
          return response.data;
        })
        .catch((error) => {
          // setError(error)
          return Promise.reject(error);
        });

      setModal(false);
      // setStart(false)
      console.log(updateData, "updateData");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <div>
      <Card className="account-cards">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Title
              style={{
                marginTop: "-1px",
                fontWeight: "bold",
                fontSize: "18px",
                fontFamily: "Roboto, sans-serif",
              }}
              level={5}
            >
              PROFILE DETAILS
            </Title>
          </div>

          <div>
            <Button
              type="primary"
              icon={<EditOutlined />}
              style={{
                marginTop: "-3px",
                width: "100px",
              }}
              onClick={() => {
                setModal(!modal);
              }}
            >
              Edit Profile
            </Button>
          </div>
        </div>

        <div style={{ marginTop: "15px" }}>
          <Row gutter={[16, 16]} className="my-account-points-card">
            {items.map((item) => (
              <React.Fragment key={item.key}>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography
                    style={{
                      color: "GrayText",
                      fontSize: "14px",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    {item.label}:
                  </Typography>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
        {/* 
        <div style={{ marginTop: "15px" }}>
          <Row gutter={[16, 16]}>
            {account_List && account_List.map((item) => (
              <React.Fragment key={item.key}>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography style={{ color: "GrayText", fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
                    {!isEmpty(item.label) ? item.label :""}:
                  </Typography>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Typography style={{ fontWeight: "bold" }}>
                  {!isEmpty(item.value) ? item.value :""}:
                  </Typography>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div> */}

        <Divider />

        <Typography
          style={{
            fontFamily: "Roboto, sans-serif",
            fontSize: "16PX",
          }}
        >
          Points Summary
        </Typography>

        <div style={{ backgroundColor: "#F5F5F5", marginTop: "10px" }}>
          <div
            className="profile-stats-container"
            ref={scrollRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          >
            <ul className="profile-stats-ul">
              <li
                className="profile-stats-li"
                style={{
                  marginLeft: "20px",
                }}
              >
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={lifeTime}
                        alt="Lifetime Points"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        style={{ marginLeft: "5px", whiteSpace: "nowrap" }}
                      >
                        Lifetime Points
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        0
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={AvailablePoints}
                        alt="Available Points"
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        style={{ marginLeft: "4px", whiteSpace: "nowrap" }}
                      >
                        Available Points
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        0
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={pointsRedeemed}
                        alt="Points Redeemed"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        style={{ marginLeft: "5px", whiteSpace: "nowrap" }}
                      >
                        Points Redeemed
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        0
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
              <li className="profile-stats-li">
                <Card
                  style={{
                    width: "180px",
                    height: "80px",
                    margin: "15px 15px",
                  }}
                >
                  <Row>
                    <Col span={6}>
                      <Image
                        preview={false}
                        src={expired}
                        alt="Points Near Expire"
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                    <Col span={18}>
                      <Typography.Text
                        className="text-nowrap"
                        style={{ marginLeft: "2px", whiteSpace: "nowrap" }}
                      >
                        Points Near Expire
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        style={{
                          marginLeft: "35px",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        N/A
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </li>
            </ul>
          </div>
        </div>
      </Card>
      {/* Edit profile modal */}
      <Modal
        open={modal}
        onCancel={() => {
          setModal(!modal);
        }}
        centered
        footer={[
          <Button key="back" onClick={() => setModal(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => updateProfile()}>
            Update
          </Button>,
        ]}
      >
        <Title
          style={{
            marginTop: "-5px",
            fontWeight: "bold",
            fontSize: "18px",
          }}
          level={5}
        >
          PROFILE DETAILS
        </Title>
        <Divider className="w-[112%] ml-[-24px]" />
        <Form
          className="custom-form"
          style={{
            marginTop: "5px",
          }}
        >
          <Row gutter={[0, 8]}>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">
                  First Name
                </Typography>
                <Input
                  placeholder=" Enter First Name"
                  size="small"
                  name="firstName"
                  value={userInfoData.firstName}
                  onChange={(e) => handleChange(e)}
                  style={{
                    width: "200px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "firstName",
                    userInfoData.firstName,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">
                  Last Name
                </Typography>
                <Input
                  placeholder=" Enter Last Name"
                  size="small"
                  name="lastName"
                  value={userInfoData.lastName}
                  onChange={(e) => handleChange(e)}
                  style={{
                    width: "200px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "lastName",
                    userInfoData.lastName,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[0, 8]}>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">Email</Typography>
                <Input
                  placeholder="Enter Email"
                  size="small"
                  name="email"
                  value={userInfoData.email}
                  onChange={(e) => handleChange(e)}
                  style={{
                    width: "200px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "email",
                    userInfoData.email,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: "8px" }}>
                <Typography className="font-semibold mb-1">
                  Date of Birth
                </Typography>
                <DatePicker
                  placeholder=" DOB"
                  value={dobDate}
                  onChange={(date) => {
                    setDob(date);
                  }}
                  format="YYYY-MM-DD"
                  size="small"
                  style={{
                    width: "200px",
                    height: "40px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "date of birth",
                    dobDate,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[0, 8]}>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">Mobile</Typography>
                <Input
                  placeholder="Enter Mobile"
                  size="small"
                  name="mobile"
                  value={userInfoData.mobile}
                  onChange={(e) => handleChange(e)}
                  style={{
                    width: "200px",
                  }}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item style={{ marginBottom: "8px" }}>
                <Typography className="font-semibold mb-1">
                  Anniversary
                </Typography>
                <DatePicker
                  placeholder="Anniversary"
                  size="small"
                  value={anniversaryDate}
                  onChange={(date) => {
                    setAnniversary(date);
                  }}
                  format="YYYY-MM-DD"
                  placement="Top-bottom"
                  style={{
                    width: "200px",
                    height: "40px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "Anniversary",
                    anniversaryDate,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[0, 8]}>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">Gender</Typography>
                <Select
                  allowClear
                  size="small"
                  value={gender}
                  onChange={(e) => setGender(e)}
                  style={{
                    width: "200px",
                    height: "40px",
                  }}
                  placeholder={"Select Gender"}
                  options={[
                    {
                      value: "Male",
                      label: "Male",
                    },
                    {
                      value: "Female",
                      label: "Female",
                    },
                    {
                      value: "Others",
                      label: "Others",
                    },
                  ]}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "Gender",
                    gender,
                    "required"
                  )}
                </p>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">Source</Typography>
                <Select
                  allowClear
                  size="small"
                  value={source}
                  onChange={(e) => setSource(e)}
                  style={{
                    width: "200px",
                    height: "40px",
                  }}
                  placeholder={"Select Source"}
                  options={[
                    { value: "Facebook", label: "Facebook" },
                    { value: "Instagram", label: "Instagram" },
                    { value: "Friends", label: "Friends" },
                    { value: "Relatives", label: "Relatives" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[0, 8]}>
            <Col span={12}>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "8px" }}
              >
                <Typography className="font-semibold mb-1">
                  Occupation
                </Typography>
                <Select
                  allowClear
                  size="small"
                  value={occupation}
                  onChange={(e) => setOccupation(e)}
                  style={{
                    width: "200px",
                    height: "40px",
                  }}
                  placeholder={"Select Occupation"}
                  options={[
                    { value: "Student", label: "Student" },
                    { value: "Laborer", label: "Laborer" },
                    { value: "Factory Work", label: "Factory Work" },
                    { value: "Owner-Operator", label: "Owner-Operator" },
                    { value: "Self Employed", label: "Self Employed" },
                    { value: "Homemaker", label: "Homemaker" },
                    { value: "Unemployed", label: "Unemployed" },
                    { value: "Retired", label: "Retired" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider className="w-[111%] ml-[-24px]" />
        </Form>
      </Modal>
    </div>
  );
};

export default Account;
